import { extend } from "jquery";


export interface BsModalConfig {
	Panel?: string;
	FadeEffect?: boolean;
}

export interface BsModalButton {
	Text?: string,
	Class?: string,
	Callback?: (evt: any) => void
}

export interface BsDisplayConfig {

	Title?: string,
	Body?: string,
	DomSelector?: string,
	DomObj?: JQuery,
	Buttons?: BsModalButton[],
	JustCloseCallback?: (evt: any) => void,
	OnVisibility?: (viz: boolean) => void,
}




export class Snackbar {


	private _template: string = `
<div id='vps_snackbar' class='snackbar'>Some text some message..</div>
`;
	private _defDuration: number = 5000;
	private _$: any;


	public get Duration(): number {
		return this._defDuration
	};
	public set Duration(duration: number) {
		this._defDuration = duration;
	};

	constructor() {
		$('body').append(this._template);
		this._$ = $("#vps_snackbar");
		console.log('constructed');
	}

	private _to: number;
	public Show(msg: string): void {

		clearTimeout(this._to);
		
		this._$.html(msg);
		this._$.addClass('show');

		this._to = setTimeout(() => {
			this._$.fadeOut(()=>{
				this._$.removeClass('show');
			})
		}, this.Duration);
	}

}




export class BsModal {
	private _cfg: BsModalConfig;
	private _diaCfg: BsDisplayConfig;


	private _defaultTemplate: string = `
    
    <!-- Modal -->
    <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal">
                        <span aria-hidden="true">
                            <i class="pe-7s-close"></i>
                        </span>
                        <span class="sr-only">
                            Close
                        </span>
                    </button>
                    <h4 class="modal-title" id="myModalLabel">Modal title</h4>
                </div>
                <div class="modal-body">
                    <!-- Modal content -->
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn green">
                        Save changes
                    </button>
                </div>
            </div>
        </div>
    </div>
`;
	// <!-- Modal -->
	// <div class="modal fade" tabindex="-1" role="dialog" 
	//             aria-hidden="false">
	//     <div class="modal-dialog" role="document">
	//       <div class="modal-content">
	//         <div class="modal-header">
	//           <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>
	//           <button type="button" class="close" aria-label="Close">
	//             <span aria-hidden="true">&times;</span>
	//           </button>
	//         </div>
	//         <div class="modal-body">
	//           ...
	//         </div>
	//         <div class="modal-footer">
	//           <button type="button" class="btn btn-secondary" id="btn">Close</button>
	//         </div>
	//       </div>
	//     </div>
	//   </div>

	// `;

	constructor(config?: BsModalConfig) {
		if (!config) config = {};
		this._cfg = config;

		this.Setup();
	}



	public Alert(html: string,
		callback?: (evt: any) => void,
		title?: string): void {

		title = Support.HasContent(title)
			? title : "Alert";

		let cfg: BsDisplayConfig = {
			Title: title,
			Body: html,
			Buttons: [
				{
					Text: "Accept",
					Class: "btn btn-primary",
					Callback: callback
				}
			],
			JustCloseCallback: callback,
		};

		this.Display(cfg);
	}


	public Confirm(html: string,
		callback: (result: boolean, evt: any) => void,
		title?: string): void {

		title = Support.HasContent(title)
			? title : "Alert";

		var confirmCallback = (result: boolean, evt: any) => {
			if (callback)
				callback(result, evt);
		}

		var accept: BsModalButton = {
			Text: "Accept",
			Class: "btn btn-primary",
			Callback: (evt) => confirmCallback(true, evt)
		};

		var cancel: BsModalButton = {
			Text: "Cancel",
			Class: "btn btn-default",
			Callback: (evt) => confirmCallback(false, evt)
		};


		let cfg: BsDisplayConfig = {
			Title: title,
			Body: html,
			Buttons: [accept, cancel],
			JustCloseCallback: (evt) => confirmCallback(false, evt),
		};

		this.Display(cfg);
	}


	private _isOn: boolean = false;
	// private _justCloseCallback: (evt: any) => void;

	public Display(cfg: BsDisplayConfig) {

		// console.log(`Is hiding... ${this._hiding}`);

		if (this._isOn) {
			console.log("There is a dialog displaying already");
			return;
		}

		if (this._hiding) {
			/*
					A DIALOG IS BEING SHOWN BUT THE PREVIOUS ONE
					DID NOT HIDE COMPLETELY.
					WAITING FOR A LITTLE BIT AND RETRYING...
			*/
			setTimeout(() => this.Display(cfg), 50);
			return;
		}


		this._isOn = true;

		this.$title.html(cfg.Title);

		this.$body.empty();
		this.$footer.empty();

		if (!cfg.Buttons || cfg.Buttons.length == 0) {
			this.$footer.hide();
		} else {
			this.$footer.show();
		}

		/*
		FIRING THE VIZ EVENT OURSELVES HERE. 
		*/
		if (cfg.OnVisibility != null)
			cfg.OnVisibility(true);


		this.$proxy = null;
		if (Support.HasContent(cfg.Body)) {
			this.$body.html(cfg.Body);
		} else {

			this.$dom = $(cfg.DomSelector);
			if (cfg.DomObj) this.$dom = cfg.DomObj;

			if (this.$dom.length == 0) {
				this.$body.html("-- NO CONTENTS TO DISPLAY --");
				//throw 'The provided DOM selector or DOM obj provided does not resolve to a DOM object';
			} else {

				/// CREATE A SPACE-HOLDER OBJECT.
				this.$proxy = $("<span><!-- spaceholder --></span>");

				/// APPEND THIS OBJECT NEXT TO THE ORIGINAL DOM.
				this.$proxy.insertAfter(this.$dom);

				/// MOVE THE DOM ONTO THE MODAL.
				///
				this.$body.append(this.$dom);
			}
		}


		if (cfg.Buttons && cfg.Buttons.length > 0) {
			cfg.Buttons.forEach(btn => {

				var thisBtn = this.$btn.clone();
				thisBtn.attr("class", btn.Class);
				thisBtn.text(btn.Text);

				thisBtn.click((evt: JQueryEventObject) => {

					this.Hide(evt);

					if (btn.Callback)
						btn.Callback(evt);

				});

				this.$footer.append(thisBtn);
			});
		}

		// this._justCloseCallback = cfg.JustCloseCallback;

		/// STORING THE DIALOG REFERENCE FOR FUTURE USE.
		this._diaCfg = cfg;

		/*
				backdrop: 'static' MAKES IT SO IT DOESN'T AUTOMATICALLY CLOSE
		*/

		this.mdl.modal({
			//backdrop: 'static'
		});

		console.log("Modal is displayed !");
	}




	private CloseRequested(evt: JQueryEventObject): any {
		this.Hide(evt);
		if (this._diaCfg.JustCloseCallback)
			this._diaCfg.JustCloseCallback(eval);
	}



	public Dismiss(): void {
		this.$closer.trigger("click");
	}



	private _hiding: boolean = false;
	private Hide(evt: any) {
		if (this._hiding) return;
		this._hiding = true;

		if (this._diaCfg.OnVisibility)
			this._diaCfg.OnVisibility(false);

		try {
			this.mdl.modal("hide");
		} catch{
			/* 
					WE ARE SEEING A FUNNY ERROR ABOUT
					Uncaught Error: Modal is transitioning
					ON THE LIVE ENV. 
			*/
			// return;
		}

		if (this.$proxy != null) {
			this.$dom.insertAfter(this.$proxy);
			this.$proxy.remove();
		}

		this.$body.empty();
		this.$footer.empty();

		this._isOn = false;
	}


	private Hiding(evt: any) {
		/// IT'S BOOTSTRAP 
		/// 
		if (!this._hiding) {
			/// IT'S HIDDING WITHOUT ANYONE REQUESTING IT...
			/// LET'S DO THE DEFAULT CLOSE BEHAVIOR.
			this.CloseRequested(evt);
		}
		// this.Hide(evt);
	}


	private Hidden(evt: any) {
		this._hiding = false;
	}


	private $proxy: JQuery;
	private $dom: JQuery;

	private $body: JQuery;
	private $title: JQuery;
	private $footer: JQuery;
	private $btn: JQuery;
	private $closer: JQuery;

	private mdl: any;




	private Setup(): void {

		var $pnl: JQuery = null;

		/// IF A PANEL WAS SPECIFIED, TRY TO USE IT, OR THROW.
		if (Support.HasContent(this._cfg.Panel)) {
			$pnl = $(this._cfg.Panel);
			if ($pnl.length == 0)
				throw "Didn't find the Modal Panel";

			$pnl = $pnl.clone();
		} else {

			/// OTHERWISE USE A DEFAULT BUILT IN PANEL.
			///
			$pnl = $("<div>" + this._defaultTemplate + "</div>");

			$pnl = $pnl.find('[role="dialog"]');;

		}

		/* THE MODAL WILL WORK ONLY IF THE TEMPLATE EXISTS ON THE DOM.
		 SO EITEHR IF WE USE A TEMPLATE, OR WE CLONE AN EXISTING PANEL,
		 IT NEEDS TO BE ADDED BACK TO THE DOM AND THIS IS WHAT IS GOING TO DRIVE
		 THE MODAL.
		 */


		$("body").append($pnl);


		this.mdl = ($pnl as any);

		// this.mdl.on("show.bs.modal", (evt: any) => this.Show(evt));
		this.mdl.on("hide.bs.modal", (evt: any) => this.Hiding(evt));
		this.mdl.on("hidden.bs.modal", (evt: any) => this.Hidden(evt));

		this.$body = $pnl.find(".modal-body");
		this.$title = $pnl.find(".modal-title");
		this.$footer = $pnl.find(".modal-footer");
		this.$btn = $pnl.find(".btn");
		this.$closer = $pnl.find(".close");

		this.$closer.click((evt) => this.CloseRequested(evt));


		if (this._cfg.FadeEffect === false) {
			$pnl.removeClass("fade");
		} else {
			$pnl.addClass("fade");
		}

		// this.$body.empty();
		// this.$footer.empty();
	};

}





export interface BlockerConfig {
	CssColor?: string;
	CssObj?: any;
	CssOpacity?: number;
	Body?: JQuery;
}



export class Blocker {

	private _defaultGif: string = "https://cdnjs.cloudflare.com/ajax/libs/semantic-ui/0.16.1/images/loader-large.gif";

	//     <div class="block-div" id="pnlBlocker">
	//     <img src="/images/KinkedInClub/site/js/loading.svg" style="position: absolute; left: 50%; top: 40%;">
	//   </div>
	private _pnl: JQuery;

	constructor(cfg?: BlockerConfig) {

		if (!cfg) cfg = {};

		this._pnl = $("<div></div>");
		this._pnl.hide();
		this._pnl.addClass("as-body-backdrop");

		let clr = Support.HasContent(cfg.CssColor)
			? cfg.CssColor : "white";

		let opa = (cfg.CssOpacity) ? cfg.CssOpacity : 0.4;

		var css: any = {
			position: 'fixed',
			top: 0,
			left: 0,
			//border: '5px solid #f00',
			backgroundColor: clr,
			opacity: opa,
			zIndex: 100,
		};
		if (cfg.CssObj) css = cfg.CssObj;

		this._pnl.css(css);


		let defaultContents = $(`
            <img src="${this._defaultGif}" style="position: absolute; left: 50%; top: 40%;">
        `);

		if (cfg.Body) defaultContents = cfg.Body;


		this._pnl.append(defaultContents);


		$("body").append(this._pnl);
	}





	public Block(): void {

		$("body").addClass("as-body-modal");

		/* MAKING IT LARGER THAN EXPECTED.
		THE CLIENT IS USING A ZOOM OUT IN THE 
		BODY WHICH RENDERS EVERYTHING SMALLER. 
		*/
		var w = $(window).width() * 1.5;
		var h = $(window).height() * 1.5;

		this._pnl.css({ width: w, height: h });
		this._pnl.fadeIn();
	}


	public Unblock(): void {
		$("body").removeClass("as-body-modal");
		this._pnl.fadeOut();
	}

}






export interface AjaxStdResponse {
	Ok: boolean;
	Msg?: string;
}



export interface UploadResult extends AjaxStdResponse{
	FilePath?: string;
	// FileName?: string;
}








export class Support {


	public static HasContent(input: string): boolean {
		if (input == null || input == undefined || input.length == 0) return false;
		return true;
	}



	public static Concat(separator: string, ...args: string[]) {
		var rval: string = "";
		var has: boolean = false;
		if (args) {
			args.forEach(a => {
				if (!Support.HasContent(a)) return;
				if (has) rval += separator;
				rval += a;
				has = true;
			});
		}
		return rval;
	}



	public static Post<T extends AjaxStdResponse>(endpoint: string, obj: any):
		Promise<T> {
		var p = new Promise<T>((accept, reject) => {

			$.ajax(endpoint,
				{
					data: JSON.stringify(obj),
					dataType: 'json',
					method: 'post',
					error: function (a, b, strError) {

						reject(strError);

					},
					success: function (data: T, status, x) {

						if (!data.Ok) {
							reject(data.Msg);
							return;
						}

						accept(data);

					}
				});


		});


		return p;
	}



}





interface DateTimePickerConfig {
	Panel?: string;
	Dom?: Element;
	DateChanged?: (sender: DateTimePicker, newDate: string) => void;
}



export class DateTimePicker {

	private _cfg: DateTimePickerConfig;
	private _tbID: string;

	constructor(cfg: DateTimePickerConfig) {
		this._cfg = cfg;
	}



	private _isDrawn: boolean = false;
	public Draw(): void {
		if (this._isDrawn) return;
		this._isDrawn = true;

		/*
				BASED ON THIS.
				https://tempusdominus.github.io/bootstrap-4/
		*/

		let id = "datetimepicker_" + new Date().getTime();

		this._tbID = id + "_tb";

		let TEMPLATE: string = `
                    <div class="form-group">
                        <div class="input-group date" id="${id}" data-target-input="nearest">
                            <input type="text" class="form-control datetimepicker-input"
                               data-target="#${id}" id="${this._tbID}" />
                            <span class="input-group-addon" data-target="#${id}" 
                                    data-toggle="datetimepicker">
                                <span class="fa fa-calendar"></span>
                            </span>
                        </div>
                    </div>
            `;

		let pnl = $(this._cfg.Panel);

		if (pnl.length == 0) pnl = $(this._cfg.Dom);

		if (pnl.length == 0)
			throw "Didn't find the panel to display the calendar";

		pnl.append(TEMPLATE);

		$("#" + this._tbID).on('input', (evt) => {

			let value = $(evt.target).val();
			if (this._cfg.DateChanged)
				this._cfg.DateChanged(this, value);

			// console.log("date changed... %s", value);
		});

		($('#' + id) as any).datetimepicker();
	}



	public SetValue(date: string): void {
		$("#" + this._tbID).val(date);
	}






}













// WEBPACK FOOTER //
// ./js/TS_Controls.ts